export default "__VITE_ASSET__BoxjFyQd__"